import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock } from "vue"

import { i18n } from '@/i18n';
import { FilterModalType, FreeColumnFilterContentItem } from './filterModal';
import MultipleSelectInput from '../SelectInput/MultipleSelectInput.vue';
import { computed, onMounted, ref, watch } from 'vue';
import { diContainer } from '@/coreContainer/container';
import { FilterInfoState } from '../SelectInput/interface/uiState';
import { UNASSIGNED_COLUMN } from '@/coreDomainsModule/constants';


export default /*@__PURE__*/_defineComponent({
  __name: 'FreeColumnFilter',
  props: {
    index: {},
    modelValue: {},
    filterType: {},
    filterModalType: {},
    isOpenProp: { type: Boolean }
  },
  emits: ["loaded", "click:select-input", "update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const t = i18n.t;

const props = __props;

const emit = __emit;

const freeColumnFilterContentItems = ref<(FreeColumnFilterContentItem & { options: string[] })[]>([]);
const isOpenIndex = ref<number>(0);
const fetchState = ref<FilterInfoState>({ type: 'none' });

const selectInputIndexBase = computed(() => props.index + (props.filterType === 'AGGREGATE_FREE_COLUMN' ? 1000 : 2000));
const fetchFunc = computed(() =>
  props.filterType === 'BASE_FREE_COLUMN'
    ? diContainer.filterInfoRepository.getBaseFreeColumnValueList
    : diContainer.filterInfoRepository.getAggregateFreeColumnValueList
);

/**
 * 親から渡された選択値を取得する
 * @param columnIndex - 自由欄のindex
 */
const getSelectedValue = (columnIndex: number): string[] => {
  const selectedItem = props.modelValue?.find((item) => item.columnIndex === columnIndex);
  return selectedItem ? [...selectedItem.selectedValue] : [];
};

/**
 * a
 * @param colIndex - a
 */
const onClickSelectInput = (colIndex: number) => {
  isOpenIndex.value = colIndex;
  emit('click:select-input');
};

/**
 * a
 * @param e - a
 * @param colIndex - a
 */
const onUpdateValues = (e: string[], colIndex: number) => {
  const target = freeColumnFilterContentItems.value.find((item) => item.columnIndex === colIndex);
  if (!target) return;
  target.selectedValue = e;
  emit('update:modelValue', freeColumnFilterContentItems.value);
};

/**
 * データフェッチ
 * @param keyword - キーワード
 */
const fetch = async (keyword?: string) => {
  fetchState.value.type = 'loading';
  const result = await fetchFunc.value(keyword);
  if (result.status.type === 'error') {
    fetchState.value.type = 'error';
    freeColumnFilterContentItems.value = [];
  } else if (result.status.data.length === 0) {
    fetchState.value.type = 'zeroMatch';
    freeColumnFilterContentItems.value = [];
  } else {
    fetchState.value.type = 'success';
    freeColumnFilterContentItems.value = result.status.data.map((d) => {
      return {
        columnIndex: d.columnIndex,
        filterType: props.filterType,
        selectedValue: getSelectedValue(d.columnIndex),
        label: d.headerName,
        includeNull: false,
        options: d.values.map((v) => v || UNASSIGNED_COLUMN),
      };
    });
  }
  emit('loaded');
};

watch(
  () => props.modelValue,
  () => {
    freeColumnFilterContentItems.value.forEach((item) => {
      item.selectedValue = getSelectedValue(item.columnIndex);
    });
  },
  { deep: true }
);

onMounted(async () => {
  await fetch();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(freeColumnFilterContentItems.value, (item, forIndex) => {
    return (_openBlock(), _createBlock(MultipleSelectInput, {
      key: item.columnIndex,
      index: selectInputIndexBase.value + forIndex,
      "selected-list": item.selectedValue,
      placeholder: _unref(t)('選択してください'),
      label: item.label,
      "filter-type": props.filterType,
      "is-open-prop": props.isOpenProp && isOpenIndex.value === item.columnIndex,
      "filter-modal-type": props.filterModalType,
      "prop-options": item.options,
      "prop-paging-state": fetchState.value,
      "use-teleport": "",
      "reset-mode": "reset",
      class: "free-column-select-input",
      "onClick:selectInput": () => onClickSelectInput(item.columnIndex),
      "onUpdate:modelValue": (e) => onUpdateValues(e, item.columnIndex)
    }, null, 8, ["index", "selected-list", "placeholder", "label", "filter-type", "is-open-prop", "filter-modal-type", "prop-options", "prop-paging-state", "onClick:selectInput", "onUpdate:modelValue"]))
  }), 128))
}
}

})